import './App.css';
import React, {useEffect, useState} from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import Home from "./pages/Home.jsx"
import NotFound from "./pages/NotFound.jsx"



function App() {
    return (
      <div style={{"height":"100vh","width":"100vw"}}>
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element = {<Home/>}
            />
            <Route path="*" element={<NotFound/>}/>
          </Routes>
        </BrowserRouter>
      </div>
    )
}

// class App extends React.Component {
//   state = { details: [] }

//   componentDidMount () {
//     let data;
//     api.get('')
//       .then(res => {
//         data = res.data;
//         this.setState({
//           details: data
//         });
//       })
//       .catch(err => { })
//     }

//   render() {
//     return (
//       <div>
//         <header>Data Generated From Django</header>
//         <hr></hr>
//         {this.state.details.map((output, id) => (
//           <div key={id}>
//             <h2>{output.title}</h2>
//             <h3>{output.content}</h3>
//           </div>
//         ) )}
//       </div>
//     )
//   }

// }

// function App() {
//   return (
//     <div className="App">
//       <div>
//         <h1>This is a test from React</h1>
//       </div> 
//     </div>
//   );
// }

export default App;
